export default __webpack_public_path__ + "static/covid-3d2ee1bd74896163833ce2a361a9235e.jpg";